<template>
    <div class="inline-flex">
        <div class="btn btn-sm btn-blue" @click="showMore">
            More
            <i class="fas fa-caret-down ml-1"></i>
        </div>

        <modal @close="resetModal" ref="modalRef" width="20rem" v-if="mModal === 'showMore'" id="modalTemplates">
            <template #header>
                More Chart Options
            </template>
            <template #body>
                <div class="pb-1">
                    <ul class="more-links">
                        <li @click="turnGridModeOn">Grid View Mode</li>
                        <hr />
                        <li  @click="copy">Copy Chart Settings & Tools</li>
                        <li @click="compareChart">Comparison Chart</li>
                        <!-- <li @click="addToChartBook">Add to Chart Book</li> -->
                        <hr />
                        <li @click="saveAsTemplate">Save Settings As Template</li>
                        <li @click="navigate()">Manage Templates</li>
                        <hr />
                        <li @click="print">Print Chart Only</li>
                        <li @click="printWithInfo">Print Chart, Notes and 1Yr Values</li>
                        <hr />
                        <li @click="saveAsImage">Save the Chart as an Image</li>
                        <li @click="shareChart">Share Chart</li>
                        <li @click="download">Download Raw Data</li>
                        <hr class="md:hidden" />
                        <li @click="handleOpenInNewWindow" class="md:hidden">Full Screen Chart</li>
                        <li @click="reset" class="md:hidden">Reset Chart</li>
                    </ul>
                </div>
            </template>
        </modal>

        <comparison-modal
            v-if="mModal === 'compare'"
            @apply-comparison="applyComparison"
            @close="resetModal"
            :section="section"
            :initial-comparison="comparisons"
            :scale-value="scaleValue"
        />

        <add-to-chart-book-modal
            v-if="mModal === 'addToChartbook'"
            @saved="saveChartBook"
            @close="resetModal"
            :symbol-display="symbolDisplay"
            :chart-books="chartBooks"
        />

        <copy-to-month-modal
            v-if="mModal === 'copyToMonth'"
            @copy="copyToMonth"
            @close="resetModal"
            :symbol="symbol"
            :section="section"
        />
    </div>
</template>

<script setup>
import { ref, inject } from 'vue';

import ComparisonModal from './ComparisonModal';
import AddToChartBookModal from './AddToChartBookModal';
import CopyToMonthModal from './CopyToMonthModal';

const props = defineProps({
    symbol: String,
    symbolDisplay: String,
    chartBooks: Array,
    comparisons: Object,
    section: String,
    scaleValue: String
});

const eventBus = inject('eventBus');
const emit = defineEmits(['action', 'add-to-chart-book', 'apply-comparison', 'copyToMonth']);

const mModal = ref('');

const resetModal = () => {
    mModal.value = '';
};

const showMore = () => {
    mModal.value = 'showMore';
};

const print = () => {
    emit('action', 'print');
    resetModal();
};

const printWithInfo = () => {
    emit('action', 'printWithInfo');
    resetModal();
};

const download = () => {
    emit('action', 'exportData');
    resetModal();
};

const reset = () => {
    emit('action', 'reset');
    resetModal();
};

const saveAsTemplate = () => {
    emit('action', 'cmOpenSaveSettingsAsTemplate');
    resetModal();
};

const navigate = () => {
    const route = window.route('my-folder.chart-templates.index');
    window.location = route;
};

const addToChartBook = () => {
    mModal.value = 'addToChartbook';
};

const compareChart = () => {
    mModal.value = 'compare';
};

const handleOpenInNewWindow = () => {
    resetModal();
    const params = [
        'height=' + screen.height,
        'width=' + screen.width,
        'fullscreen=yes',
        'resizable=yes',
        'scrollbars=yes'
    ].join(',');
    // const route = window.route('interactive-charts.fullScreen', symbol.value);
    // window.open(route.toString(), '', params);
    window.open('?fullscreen=true', '', params);
};

const saveAsImage = () => {
    emit('action', 'saveAsImage');
    resetModal();
};

const saveChartBook = (chartbook) => {
    emit('add-to-chart-book', chartbook);
};

const applyComparison = (actions, settings) => {
    emit('apply-comparison', actions, settings);
};

const copy = () => {
    mModal.value = 'copyToMonth';
};

const copyToMonth = (settings) => {
    emit('copyToMonth', settings);
    resetModal();
};

const shareChart = () => {
    emit('action', 'cmSocialShare');
    resetModal();
};

const turnGridModeOn = () => {
    eventBus.emit('grid-mode-on');
    resetModal();
};

defineExpose({
    addToChartBook,
    compareChart,
});
</script>

<style lang="scss">
#modalChartBookTemplate {
    .modal-container {
        width: 24rem;
        @screen xs {
            width: 100%;
        }
    }
}

#modalTemplates {
    .modal-container {
        width: 24rem;
        @screen xs {
            width: 100%;
        }

        .more-links {
            @apply list-none m-0 p-0;

            & > li {
                @apply relative text-sm cursor-pointer text-blue-600 py-1 px-0;

                &.disabled {
                    @apply text-gray-500;
                    pointer-events: none;
                }

                a {
                    @apply text-black;
                }

                &:hover {
                    @apply cursor-pointer text-yellow-500;
                }

            }
            hr {
                @apply m-0 my-1 h-px bg-gray-400;
            }
        }
    }
}
</style>
